//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'breadcrumb',
  components: {},
  data() {
    return {}
  },
  computed: {
    routes() {
      const routes  = []
      const $routes = this.$route.matched
      if ($routes.length) {
        $routes.forEach((route) => {
          if (route.path != '/pc' 
            && route.meta 
            && route.meta.breadcrumb) {
            routes.push(route)
          }
        })
      }

      return routes
    }
  },
  methods: {

  },
  mounted() {
    this.$route.meta.stopLoading()
  }
}



// WEBPACK FOOTER //
// ./src/components/pc/el-breadcrumb.vue